/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class PageRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model(params) {
    let page = this.store.findRecord('posts/page', params.page_id, {
      include: 'tags,tagCategories',
    });
    let posts = this.store.query('posts/post', {
      pageId: params.page_id,
      include: 'comments,reactions',
    });

    let assessments = page.then((page) => {
      // assessment_ids is a StatefulArray, which JSON.stringify can't write
      // as an array; copy it to a plain array first.
      let assessmentIds = JSON.stringify([...page.assessment_ids]);
      return this.store.query('assessments/assessment', { assessmentIds });
    });
    return hash({
      page,
      posts,
      assessments,
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('application').set('currentPageId', model.page.id);
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        // Set activeAssessment on the controller so that it can highlight the correct button.
        let assessmentId = this.paramsFor('page.assessment').assessment_id;
        this.controller.set('activeAssessment', assessmentId);
      }
    });
  }
}
